import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ReportingAndDataIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ReportingAndData",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M7.57 29.29c-.63 0-1.14-.51-1.14-1.14v-3.43c0-.63.51-1.14 1.14-1.14h2.29a1.14 1.14 0 1 1 0 2.28H8.72v2.29c0 .63-.51 1.14-1.14 1.14ZM14.43 29.29c-.63 0-1.14-.51-1.14-1.14v-9.14c0-.63.51-1.14 1.14-1.14h2.29a1.14 1.14 0 1 1 0 2.28h-1.14v8c0 .63-.51 1.14-1.14 1.14ZM3 21.29c-.3 0-.61-.12-.83-.36a1.15 1.15 0 0 1 .05-1.62L20.51 2.17a1.15 1.15 0 0 1 1.62.05c.43.46.41 1.18-.05 1.62L3.78 20.98c-.22.21-.5.31-.78.31"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21.29 9.86c-.63 0-1.14-.51-1.14-1.14V4.15h-4.57a1.14 1.14 0 1 1 0-2.28h5.72c.63 0 1.14.51 1.14 1.14v5.71c0 .63-.51 1.14-1.14 1.14ZM28.14 29.29c-.63 0-1.14-.51-1.14-1.14V14.44h-4.57v13.71a1.14 1.14 0 1 1-2.28 0V13.29c0-.63.51-1.14 1.14-1.14h6.86c.63 0 1.14.51 1.14 1.14v14.86c0 .63-.51 1.14-1.14 1.14Z"
    })]
  }));
};